// Recruitment / ATS constants & helpers.

export const STAGES = ['Applied', 'Screening', 'Interview', 'Offer', 'Hired'];

export const JOB_STAGES = [
  'Draft',
  'Pending Approval',
  'Approved',
  'Published',
  'Closed',
];

export const jobTone = (s) =>
  ({
    Draft: 'neutral',
    'Pending Approval': 'warning',
    Approved: 'info',
    Published: 'success',
    Closed: 'neutral',
  })[s] || 'neutral';

export const jobName = (jobs, id) => {
  const j = jobs.find((x) => x.id === id);
  return j ? j.title : '—';
};
